import { Settings as Update } from "@material-ui/icons"
import { create, get, update } from "lodash"

export const secretKey =
  "nTasAnJN5C4!nPrM9uWg9J2*fKHfOD3*PQp0ita@4s@zBD!Tz!8Zlbm2@K9aWStj"

// Base URLs
const API_BASE_URL =
  process.env.REACT_APP_API_ENDPOINT ||
  "http://ec2-44-238-116-65.us-west-2.compute.amazonaws.com"
const KC_API_BASE_URL = process.env.REACT_APP_KC_API_ENDPOINT
const API_BASE_ROLE_URL = process.env.REACT_APP_KEYCLOAK_ROLE_ENDPOINT
const API_USER_ROLE_URL = process.env.REACT_APP_USER_DOMAIN_URL
export const DK_BASE_URL =
  process.env.REACT_APP_BASE_DOMAIN_URL || "https://dev8.digitkart.ai"

// General API URLs
export const API_URL = `${API_BASE_URL}`
export const API_KC_URL = `${KC_API_BASE_URL}`
export const API_CM_URL = `${API_BASE_URL}`.replace(
  "apigw",
  "contentmanagement"
)
export const API_UM_URL = `${API_BASE_URL}`.replace("apigw", "usermanagement")
export const API_USER_URL = `${API_USER_ROLE_URL}`.replace(
  "apigw",
  "usermanagement"
)
export const API_MD_URL = `${API_BASE_URL}`.replace("apigw", "masterdata")
export const API_DASHBOARD_URL = `${API_BASE_URL}`.replace("apigw", "dashboard")
export const API_DEVICES_URL = `${API_BASE_URL}`.replace(
  "apigw",
  "frictionless"
)
export const API_LOCATION_URL = `${API_BASE_URL}`.replace("apigw", "location")
export const API_INVENTORY_URL = `${API_BASE_URL}`.replace("apigw", "inventory")
export const API_AUGMENTATION_URL = `${API_BASE_URL}`.replace(
  "apigw",
  "augmentation"
)
export const API_CL_URL = `${API_BASE_URL}`.replace(
  "apigw",
  "continuouslearning"
)
export const API_RECEIPT_URL = `${API_BASE_URL}`.replace("apigw", "receipt")
export const API_PG_URL = `${KC_API_BASE_URL}`.replace("/api/frictionless", "")

// Specific URLs
export const API_URL_STORES = `${API_BASE_URL}`
export const API_URL_CUSTOMERS = `${API_BASE_URL}`
export const API_URL_CUSTOMERS_NO_PROXY = `${API_BASE_URL}`
export const API_URL_ROLES = `${API_BASE_ROLE_URL}`
export const API_URL_CUSTOMERS_COMMON = `${API_BASE_URL}`
export const API_URL_USER = `${API_BASE_URL}`
export const API_URL_PRICES = `${API_BASE_URL}`
export const API_URL_INVENTORY = `${API_BASE_URL}`
export const API_URL_LOC_HIERARCHY = `${API_BASE_URL}/api/stores/locationHierarchy`
export const API_URL_PRODUCT = `${API_BASE_URL}`
export const SAMPLE_FILE_TEMPLATE = "/api/products/getFileTemplate"

// Location Hierarchy URLs
export const LOC_HIERARCHY_URLS = {
  baseURL: `${API_MD_URL}/api/stores`,
  baseURL_KC: `${KC_API_BASE_URL}/api/kc`,
  endpoints: {
    getLocations: "/getlocations",
    getLocationGroups: "/getlocationgroups",
    getLocationHierarchy: "/locationHierarchy",
    create: "/createlocationHierarchy",
    updateHierarchy: "/updatelocationHierarchy/:hierarchyID",
    deleteHierarchy: "/deletelocationHierarchy/:hierarchyID",
    updateLocationHierarchyMappings: "/updateLocationHierarchyMappings",
    deleteLocationGroups: "/api/stores/deletelocationgroups",
    deleteLocation: "/deletelocation",
    searchLocations: "/searchlocations",
    searchKcLocations: "/searchLocationstest",
  },
}

// Product Category URLs
export const PRODUCT_CATEGORY_URLS = {
  baseURL: `${API_MD_URL}/api/productcategory`,
  endpoints: {
    getAll: "/getall",
    create: "/create",
    fetchCategory: "/:categoryID",
    updateCategory: "/update/:categoryID",
    deleteCategory: "/delete/:categoryID",
  },
}

// Product Data URLs
export const PRODUCT_DATA_URLS = {
  baseURL: `${API_MD_URL}/api/products`,
  endpoints: {
    getProducts: "/getProducts",
    exportAllProduct: "/exportAllProduct",
    getProductCategories: "/productCategory",
    createCategory: "/createProductCategory",
    updateCategory: "/updateProductCategory",
    deleteCategory: "/deleteProductCategory",
    getAllWithPagination: "/paginate",
    getAllProductGroupsWithPagination: "/getproductgroups",
    deleteProductMany: "/api/products/deletemany",
    deleteProductGroups: "/api/products/deleteProductGroups",
    getProductById: "/getProductById",
    updateProduct: "/update",
    searchAttributes: "/searchAttributes",
    updateProductCategoryMappings: "/updateProductCategoryMappings",
    getProductCategoryById: "/getProductCategoryById",
    searchProducts: "/searchProducts",
    getProductsAttribute: "/getProductAttributes",
    createProductAttribute: "/createProductAttribute",
    getProductAttrById: "/productattribute",
    updateProductAttribute: "/updateProductAttribute",
  },
}

// Loyalty Management URLs
export const LOYALTY_MANAGEMENT_URLS = {
  baseURL: `${DK_BASE_URL}/api/loyalty`,
  endpoints: {
    getLoyaltyManagement: "/api/content/loyalty/getloyaltylist",
    createLoyaltyManagement: "/api/content/loyalty/create",
    deleteLoyaltyManagement: "/api/content/loyalty/deletemany",
    updateLoyaltyManagement: "/api/content/loyalty/update",
    lastSyncLoyalty: "/api/content/loyalty/getLastUpdated",
    locationLoyaltyBulkUploadLogs:
      "/api/content/loyalty/getLoyaltyUploadLogList",
  },
}

// Loyalty Configurations URLs
export const LOYALTY_CONFIGURATION_URLS = {
  baseURL: `${DK_BASE_URL}/api/loyalty`,
  endpoints: {
    createLoyalty: "/api/content/loyaltyconfig/createloyaltyconfig",
    updateLoyalty: "/api/content/loyaltyconfig/updateloyaltyconfig",
    gettenantdetails: "/api/content/loyaltyconfig/gettenantdetails",
    getloyaltyconfiglist: "/api/content/loyaltyconfig/getloyaltyconfiglist",
    getSelectedTenantDetails: "/api/content/loyaltyconfig/getloyaltyconfig",
    deleteLoyaltyMany: "/api/content/loyaltyconfigloyalconfig/deletemany",
  },
}

// Loyalty Data URLs
export const LOYALTY_DATA_URLS = {
  baseURL: `${API_MD_URL}/api/loyalty`,
  endpoints: {
    getProducts: "/getProducts",
  },
}

// Device Data URLs
export const DEVICE_DATA_URLS = {
  baseURL: `${API_MD_URL}/api/stores`,
  baseURL_KC: `${KC_API_BASE_URL}/api/kc`,
  baseURL_KC_TEST: `${API_DEVICES_URL}/api/kc`,
  baseURL_dashboard: `${API_DASHBOARD_URL}/api/dashboardInfo`,
  endpoints: {
    getLocations: "/getlocations",
    getTenants: "/gettenants",
    getTenantsInfo: "/getTenantsInfo",
    getlocationDetails: "/getlocationDetails",
    getPOSinformation: "/getposinformation",
    getdevicesinformation: "/getdevicesinformation",
  },
}

// Master Data URLs
export const MASTER_DATA_URLS = {
  baseURL: `${DK_BASE_URL}/api/masterdata`,
  endpoints: {
    bulkUploadProductStatus: "/api/products/getBulkUploadProductsStatus",
    bulkUploadProducts: "/api/products/bulkUploadProducts",
    bulkUploadLogs: "api/products/getProductsUploadLogList",
    exportAllProducts: "/api/products/exportAllProduct",
    bulkDownloadProductStatus: "/api/products/getProductsExportStatus",
    archieveProductsStatus: "/api/products/archiveProductsStatus",
    archieveProductsMappingStatus: "/api/products/archiveProductMappingStatus",
    locationProductsBulkUploadStatus:
      "/api/products/getBulkUploadProductMappingStatus",
    locationProductsBulkUpload: "/api/products/bulkUploadProductMappings",
    locationProductsBulkUploadLogs:
      "/api/products/getProductMappingUploadLogList",
    locationBulkDownloadProductMappingStatus:
      "/api/products/getProductsMappingExportStatus",
    locationExportAllProductsMapping: "/api/products/exportAllProductMappings",
  },
}

//Loyalty Management Import/Export Data URLs
export const LOYALTY_MASTER_DATA_URLS = {
  baseURL: `${DK_BASE_URL}/api/loyalty`,
  endpoints: {
    //Loyalty
    bulkDownloadLoyaltyStatus: "/api/content/loyalty/getLoyaltyExportStatus",
    bulkUploadLoyaltyStatus: "/api/content/loyalty/getBulkUploadLoyaltyStatus",
    exportAllLoyalty: "/api/content/loyalty/bulkExportLoyalty",
    archieveLoyaltyStatus: "/api/content/loyalty/archiveLoyaltyStatus",
    bulkUploadLoyalty: "/api/content/loyalty/bulkUploadLoyalty",
    createLoyaltyConfig: "/api/content/loyaltyconfig/createloyaltyconfig",
    locationLoyaltyBulkUploadLogs:
      "/api/content/loyaltyconfig/getLoyaltyUploadLogList",

      
    //Product
    bulkUploadLogs: "api/products/getProductsUploadLogList",
    archieveProductsMappingStatus: "/api/products/archiveProductMappingStatus",
    locationProductsBulkUploadStatus:
      "/api/products/getBulkUploadProductMappingStatus",
    locationProductsBulkUpload: "/api/products/bulkUploadProductMappings",
    // locationProductsBulkUploadLogs:
    //   "/api/products/getProductMappingUploadLogList",
    locationBulkDownloadProductMappingStatus:
      "/api/products/getProductsMappingExportStatus",
    locationExportAllProductsMapping: "/api/products/exportAllProductMappings",
  },
}

// Inventory Data URLs
export const INVENTORY_DATA_URLS = {
  baseURL: `${DK_BASE_URL}/api/inventory`,
  endpoints: {
    bulkUploadInventoryStatus: "/api/kc/getBulkUploadInventoryCountStatus",
    bulkExportInventoryStatus: "/api/kc/getInventoryCountExportStatus",
    archieveInventoryStatus: "/api/kc/archiveInventoryCountStatus",
    bulkUploadInventoryData: "/api/kc/bulkUploadInventoryCount",
    bulkExportInventoryData: "/api/kc/exportAllInventoryCount",
    bulkUploadInventoryLogs: "/api/kc/getInventoryCountUploadLogList",
    getSupplierList: "/api/supplier/getsupplierlist",
    getSupplierType:"api/getsuppliertype",
    createSupplier: "/api/supplier/create",
    deleteSuppliers:"/api/supplier/deletemany",
    getSupplierById:"/api/supplier/getsupplier/",
    updateSupplierById:"/api/supplier/update/",
    getPurchaseList:"/api/kc/purchase/list",
    getPurchaseStatusList:"/api/getpurchasestatus",
    createPurchaseOrder:"/api/kc/purchase/create",
    updatePurchaseOrder:"/api/kc/purchase/update/",
    getPurchaseOrderById:"/api/kc/purchase/get/",
    deletePurchaseOrders:"/api/kc/purchase/deletemany",
    exportPurchaseOrders:"/api/kc/purchase/export",
    getBulkUploadPurchaseStatus:"/getBulkUploadPurchaseStatus",
    archivePurchaseStatus:"/archivePurchaseStatus",
    bulkUploadPurchaseProducts:"/api/kc/purchase/bulkUploadPurchaseProducts/",
    getPurchaseUploadLogList:"/getPurchaseUploadLogList",
    exportInventoryCurrentStock:"/inventory/stock/export",
  },
}

// Language Data URLs
export const LANGUAGE_DATA_URLS = {
  baseURL: `${DK_BASE_URL}/api/contentmanagement`,
  endpoints: {
    getBulkUploadLanguageStatus: "/api/language/getBulkUploadLanguageStatus",
    getBulkExportLanguageStatus: "/api/language/getBulkExportLanguageStatus",
    bulkImportLanguageData: "/api/language/bulkImportLanguageData",
    bulkExportLanguageData: "/api/language/bulkExportLanguageData",
    bulkUploadLanguageArchieve: "/api/language/archiveLanguageStatus",
    bulkUploadLanguageLogs: "/api/language/getLanguageUploadLogList",
  },
}

// Content Management Product Category URL
export const API_CM_PC_URL = `${API_BASE_URL}`.replace(
  "apigw",
  "contentmanagement"
)
